module.exports = __webpack_public_path__ + "static/media/IMG_7732.8fb6094a.JPG";